import { t } from '../../app/i18n';

export default {
  CAK: 'CAK',
  ZAM: 'ZAM',
  AKT: 'AKT',
  UHR: 'UHR',
};

export const translation = {
  CAK: t('čakajúce'),
  ZAM: t('zamietnuté'),
  AKT: t('aktívne'),
  UHR: t('uhradené'),
};



// WEBPACK FOOTER //
// ./src/common/enums/loanHistoryStatus.js